import { useQuery } from '@tanstack/react-query';
import { useWatch } from 'react-hook-form';
import { fetcher } from '../utils/fetcher.js';
import { getHuckConfig } from '../utils/getHuckConfig.js';

export const usePostalPlace = () => {
  const config = getHuckConfig();
  const postalCode = useWatch({ name: 'address.postalcode' });

  const minPostalCodeLength: Record<(typeof config)['brand'], number> = {
    /**
     * Faroe Islands postal codes are 3 digits
     */
    dba: 3,
    finn: 4,
    blocket: 4,
    bilbasen: 3,
  };

  const { data } = useQuery<{ postalName?: string }>({
    queryKey: ['pelias-search', postalCode],
    queryFn: () => fetcher(`${config.root}/api/postalcode-lookup/${postalCode}`),
    enabled: Number.isFinite(Number(postalCode)) && postalCode.length >= minPostalCodeLength[config.brand],
    retry: (failureCount, error) => error.message?.includes('status: 504') && failureCount < 3, // Retry on 504 Gateway Timeout
    retryDelay: (retryAttempt) => Math.min(retryAttempt * 1000, 5000),
  });

  return data?.postalName;
};
